import { SET_QUERY_STRING_WITHOUT_COORDINATES } from 'ACTIONS';

export const setListQueryStringWithoutCoordinates = (payload, location, ppType) => dispatch => dispatch({
    type: SET_QUERY_STRING_WITHOUT_COORDINATES,
    payload,
    location,
    ppType
});
